
// import { login, logout } from '../action/auth-actions';
// import superagent from 'superagent';

// let refreshingToken = false;
// let queuedActions = [];
// let makeErrorFree = false;

// export default (store) => (next) => (action) => {
//   let auth = store.getState().auth;

//   // Prevent infinite loop by allowing LOGOUT to proceed normally
//   if (action.type === 'LOGOUT') {
//     return next(action);
//   }

//   // // Queue actions while refreshing token
//   // if (refreshingToken) {
//   //   queuedActions.push(action);
//   //   return;
//   // }

//   if (action.type === 'LOGIN') {
//     makeErrorFree = false;
//     return next(action);
//   }

//   // // Token expiration check
//   // if (auth && auth.refreshToken) {
//   //   const thresholdMinutes = 0;
//   //   const now = Date.now();
//   //   const expiresCurrent = new Date(auth.expires).getTime();

//   //   if (expiresCurrent - now <= thresholdMinutes * 60000 && !refreshingToken) {
//   //     refreshingToken = true;
//   //     makeErrorFree = true;

//   //     superagent
//   //       .get(`${__API_URI__}/auth/refresh/${auth.refreshToken}`)
//   //       .set('Content-Type', 'application/json')
//   //       .set('Authorization', `Bearer ${auth.token}`)
//   //       .set('Platform', 'Web')
//   //       .set('Version', `${__version__}`)
//   //       .end((err, res) => {
//   //         refreshingToken = false;

//   //         if (err) {
//   //           if (makeErrorFree) {
//   //             store.dispatch(logout());
//   //             makeErrorFree = false;
//   //           }
//   //         } else {
//   //           let token = res.body;
//   //           store.dispatch(login(token));
//   //           makeErrorFree = false;

//   //           // Dispatch queued actions after refresh
//   //           queuedActions.forEach((queuedAction) => store.dispatch(queuedAction));
//   //           queuedActions = [];
//   //         }
//   //       });

//   //     return;
//   //   }
//   // }

//   // If action is a function (Thunk), pass token
//   if (typeof action === 'function') {
//     return action(store.dispatch, store.getState, auth?.token);
//   }

//   return next(action);
// };


// working fine but delaying

// import { login, logout } from '../action/auth-actions';
// import superagent from 'superagent';

// let refreshingToken = false;
// let makeErrorFree = false;

// const actionTimers = new Map(); // Stores timers per action type
// const lastQueuedAction = new Map(); // Stores the most recent action in the queue

// export default (store) => (next) => (action) => {
//   let auth = store.getState().auth;

//   console.log(`[Middleware] Received Action: ${action.type}`, new Date().toLocaleTimeString());

//   // Prevent infinite loop by allowing LOGOUT to proceed normally
//   if (action.type === 'LOGOUT') {
//     // console.log(`[Middleware] Executing LOGOUT immediately`);
//     return next(action);
//   }

//   if (action.type === 'LOGIN') {
//     makeErrorFree = false;
//     return next(action);
//   }

//   // If action is a function (Thunk), pass token
//   if (typeof action === 'function') {
//     return action(store.dispatch, store.getState, auth?.token);
//   }

//   if (action.type) {
//     if (!actionTimers.has(action.type)) {
//       // console.log(`[Middleware] Executing ${action.type} immediately`);

//       // First call: Execute immediately
//       next(action);

//       // Start the 3-second timer
//       actionTimers.set(
//         action.type,
//         setTimeout(() => {
//           if (lastQueuedAction.has(action.type)) {
//             // console.log(`[Middleware] Executing last queued action: ${action.type}`);
//             next(lastQueuedAction.get(action.type)); // Execute the latest action
//             lastQueuedAction.delete(action.type);
//           }
//           actionTimers.delete(action.type); // Remove the timer after execution
//         }, 2000)
//       );
//     } else {
//       console.log(`[Middleware] Holding ${action.type}, will execute last queued action after 3 seconds`);
//       lastQueuedAction.set(action.type, action);
//     }

//     return; // Prevent immediate dispatch for queued actions
//   }

//   return next(action);
// };


let actionTimers = new Map();
let lastQueuedAction = new Map();
let lastActionPayload = new Map();

export default (store) => (next) => (action) => {
  let auth = store.getState().auth;

  if (typeof action === 'function') {
    return action(store.dispatch, store.getState, auth?.token);
  }

  if (action.type) {
    // 🛑 **Avoid circular JSON error**: Manually remove `mapInstance`
    let sanitizedPayload = { ...action.payload };
    if (sanitizedPayload && sanitizedPayload.mapInstance) {
      delete sanitizedPayload.mapInstance;
    }

    // Compare objects manually (shallow comparison)
    let isSamePayload = lastActionPayload.has(action.type) &&
      compareObjects(lastActionPayload.get(action.type), sanitizedPayload);

    if (!actionTimers.has(action.type) || !isSamePayload) {
      // console.log(`[Middleware] Executing ${action.type} immediately`);

      next(action);
      lastActionPayload.set(action.type, sanitizedPayload);

      actionTimers.set(
        action.type,
        setTimeout(() => {
          if (lastQueuedAction.has(action.type)) {
            // console.log(`[Middleware] Executing last queued action: ${action.type}`);
            next(lastQueuedAction.get(action.type));
            lastQueuedAction.delete(action.type);
          }
          actionTimers.delete(action.type);
          lastActionPayload.delete(action.type);
        }, 2000)
      );
    } else {
      // console.log(`[Middleware] Holding ${action.type} with same payload for 3 seconds`);
      lastQueuedAction.set(action.type, action);
    }

    return;
  }

  return next(action);
};

// **Helper function for shallow object comparison**
function compareObjects(obj1, obj2) {
  if (!obj1 || !obj2) return false;
  let keys1 = Object.keys(obj1);
  let keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) return false;

  for (let key of keys1) {
    if (obj1[key] !== obj2[key]) return false;
  }
  return true;
}


